// Achievement.js
import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import CountUp from "react-countup";
import {
  FaUsers,
  FaProjectDiagram,
  FaAward,
  FaUsersCog,
  FaBook,
  FaLightbulb,
  FaBookOpen,
  FaCertificate,
} from "react-icons/fa";

import "./Achievement.css";

function Achievement() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const section = document.getElementById("achievements");
    if (!section) return;

    const onScroll = () => {
      const top = section.getBoundingClientRect().top;
      const height = window.innerHeight;

      if (top < height * 0.75) {
        setShow(true);
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll(); // run once

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="achievements-wrapper" aria-labelledby="achievement-title">
      <header className="section-title">
        <h2 id="achievement-title" className="sections-heading">
          Our Achievements
        </h2>
        <p className="section-subheading">Things we are proud of</p>
      </header>

      <Element
        id="achievements"
        name="achievements"
        className={`achievements ${show ? "show" : ""}`}
      >
        <AchievementCard
          icon={<FaUsers />}
          title="Clients Served"
          value={70}
          show={show}
        />
        <AchievementCard
          icon={<FaProjectDiagram />}
          title="Projects Completed"
          value={55}
          show={show}
        />
        <AchievementCard
          icon={<FaAward />}
          title="Awards & Recognition"
          value={27}
          show={show}
        />
        <AchievementCard
          icon={<FaUsersCog />}
          title="Team Members"
          value={31}
          show={show}
        />
        <AchievementCard
          icon={<FaBook />}
          title="Publications"
          value={20}
          show={show}
        />
        <AchievementCard
          icon={<FaLightbulb />}
          title="Patents Published"
          value={4}
          show={show}
        />
        <AchievementCard
          icon={<FaBookOpen />}
          title="Books Published"
          value={2}
          show={show}
        />
        <AchievementCard
          icon={<FaCertificate />}
          title="Patents Granted"
          value={2}
          show={show}
        />
      </Element>
    </section>
  );
}

function AchievementCard({ icon, title, value, show }) {
  return (
    <article className="achievement-card">
      <div className="achievement-icon">{icon}</div>
      <h3 className="achievement-title">{title}</h3>
      <div className="achievement-number">
        {show && <CountUp end={value} duration={2.5} />}+
      </div>
    </article>
  );
}

export default Achievement;
